import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  width: 100%;
  margin-top: 20px;
  margin-bottom: 80px;

`;

export const ContainerAgreements = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;

  width: 80%;
`;

export const Botton = styled.div`
display: flex;
  justify-content: center;
  align-items: center;

  border: 1px solid var(--primary);

  width: 300px;
  height: 60px;

  border-radius: 15px;
  margin-left: 100px;

  background: var(--primary);

  cursor: pointer;
  span {
    color: #fff;
    width: 300px;
    font-weight: 900;

    font-size: 18px;
    text-align: center;
  }

`;
